import React from 'react';
import { motion } from 'framer-motion';
import { Grid3x3, Orbit, BarChart3, Shield, Terminal, FileText, RefreshCw } from 'lucide-react';
import PremiumButton from '../ui/PremiumButton';
import { SPRING_CONFIG } from '../../utils/constants';

const ProfileHeader = ({ activeTab, setActiveTab, fetchUserData }) => {
  const tabs = [
    { id: "overview", icon: <Grid3x3 className="w-4 h-4" />, label: "Overview", color: "#15FF75" },
    { id: "constellation", icon: <Orbit className="w-4 h-4" />, label: "Constellation", color: "#2CF98E" },
    { id: "analytics", icon: <BarChart3 className="w-4 h-4" />, label: "Analytics", color: "#00D4FF" },
    { id: "passport", icon: <Shield className="w-4 h-4" />, label: "Passport", color: "#FFB800" },
    { id: "arns", icon: <Terminal className="w-4 h-4" />, label: "ArNS", color: "#FF4747" },
    { id: "history", icon: <FileText className="w-4 h-4" />, label: "History", color: "#8B5CF6" },
  ];
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-6">
        <motion.h1 
          className="text-3xl font-bold text-[#E8FDF2]"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          Profile Dashboard
        </motion.h1>
        
        <div className="flex items-center gap-3">
          <PremiumButton
            variant="secondary"
            disabled={false}
            size="sm"
            onClick={fetchUserData}
            icon={<RefreshCw className="w-4 h-4" />}
          >
            Refresh
          </PremiumButton>
        </div>
      </div>
      
      {/* Tab Navigation */}
      <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide">
        {tabs.map((tab, index) => (
          <motion.button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`group relative flex items-center gap-2 px-6 py-3 rounded-2xl font-medium whitespace-nowrap transition-all duration-500 ${
              activeTab === tab.id
                ? 'text-[#0A0E1B]'
                : 'text-[#8AA5A2] hover:text-[#E8FDF2]'
            }`}
            style={{
              background: activeTab === tab.id 
                ? `linear-gradient(135deg, ${tab.color}, ${tab.color}CC)`
                : 'transparent',
              boxShadow: activeTab === tab.id 
                ? `0 8px 32px ${tab.color}40`
                : 'none'
            }}
            whileHover={{ scale: 1.02, y: -2 }}
            whileTap={{ scale: 0.98 }}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1, ...SPRING_CONFIG }}
          >
            {activeTab !== tab.id && (
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-white/[0.03] to-transparent group-hover:border-white/[0.1] transition-all duration-300" />
            )}
            <span className="relative z-10">{tab.icon}</span>
            <span className="relative z-10 text-base">{tab.label}</span>
            
            {activeTab === tab.id && (
              <motion.div
                className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-12 h-1 rounded-full"
                style={{ backgroundColor: tab.color }}
                layoutId="activeTab"
                transition={SPRING_CONFIG}
              />
            )}
          </motion.button>
        ))}
      </div>
    </div>
  );
};
export default ProfileHeader;